import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  locations: {},
});

export function setProduct(state, location) {
  const arr = Array.isArray(location) ? location : [location];
  return state
    .mergeIn(['locations'], fromJS(arr.reduce((obj, loc) => ({ ...obj, [loc.id]: loc }), {})));
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'LOCATIONS_SET':
      return setProduct(state, action.locations);

    case 'LOCATIONS_REMOVE':
      return state.deleteIn(['locations', action.id]);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/locations.js